import { useAuth0 } from "@auth0/auth0-react";

export function useAppointmentAdminAPI() {
  const { getAccessTokenSilently } = useAuth0();

  const fetchWithAuth = async (url, options = {}) => {
    const accessToken = await getAccessTokenSilently();
    const headers = new Headers(options.headers || {});
    headers.append("Authorization", `Bearer ${accessToken}`);
    return fetch(url, { ...options, headers });
  };

  const getServices = async () => {
    const url = `${process.env.REACT_APP_BACK_API}/reservations/admin/services`;
    const res = await fetchWithAuth(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json(); // [{ name: string }]
  };

  const getAppointmentsForDay = async (date) => {
    // date: JS Date
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // 1-based
    const day = date.getDate();
    const qp = new URLSearchParams({ year, month: String(month), day: String(day) }).toString();
    const url = `${process.env.REACT_APP_BACK_API}/reservations/admin/appointments?${qp}`;
    const res = await fetchWithAuth(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json(); // Array of AppointmentDto
  };

  return { getServices, getAppointmentsForDay };
}
